import React from 'react';

const renderWidgetsSection = (widgetsSection, legend, isLegendTopPosition) =>
    isLegendTopPosition ? (
        <>
            {legend}
            {widgetsSection}
        </>
    ) : (
        <>
            {widgetsSection}
            {legend}
        </>
    );

export default renderWidgetsSection;
